import { render, staticRenderFns } from "./DriverDataPage.vue?vue&type=template&id=a635a11e&scoped=true&"
import script from "./DriverDataPage.vue?vue&type=script&lang=js&"
export * from "./DriverDataPage.vue?vue&type=script&lang=js&"
import style0 from "./DriverDataPage.vue?vue&type=style&index=0&id=a635a11e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a635a11e",
  null
  
)

export default component.exports